import {Component, input, OnInit, output, ViewChild} from '@angular/core';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatFooterCell,
  MatFooterCellDef,
  MatFooterRow,
  MatFooterRowDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from '@angular/material/table';
import {ShiftReportRecordModel, ShiftReportTotalModel} from '../../../../shared/models/shift.model';
import {ConfigurationModel} from '../../../../shared/models/configuration.model';
import {ShiftReportColumn} from '../shift-report/ShiftReportColumn';
import {InsightsRoute} from '../../insights-routing.module';
import {RouterLink} from '@angular/router';
import {FormattingModule} from '../../../../shared/formatting/formatting.module';
import {DatePipe} from '@angular/common';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {ElementVisibleDirective} from '../../../../shared/directives/element-visible.directive';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  imports: [
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    RouterLink,
    MatFooterCell,
    MatSortHeader,
    MatFooterCellDef,
    FormattingModule,
    DatePipe,
    MatIconButton,
    MatIcon,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatFooterRow,
    MatFooterRowDef,
    MatHeaderRowDef,
    ElementVisibleDirective,
    MatProgressSpinner,
  ],
  selector: 'app-shift-report-table',
  styleUrls: ['./shift-report-table.component.scss'],
  templateUrl: './shift-report-table.component.html'
})
export class ShiftReportTableComponent implements OnInit {

  configuration = input<ConfigurationModel>();
  @ViewChild(MatSort) sort: MatSort;

  columns= input<ShiftReportColumn[]>();
  dataSource = input<MatTableDataSource<ShiftReportRecordModel>>();
  reportTotal = input<ShiftReportTotalModel | null>();

  loadingData = input<boolean>(false)

  sortChangedEvent = output<void>();
  tableBottomVisible = output<boolean>();

  displayedColumnsWithAction: string[];

  InsightsRoute = InsightsRoute;

  ngOnInit(): void {
    const displayedColumns = this.columns()?.map(value => value.id);
    this.displayedColumnsWithAction = [...displayedColumns];
  }

  isColumnHidden(columnId: string): boolean {
    return this.columns()?.find(value => !value.displayed && value.id === columnId) != null;
  }

  getSort(): string | undefined {
    if (!this.sort.active) {
      return undefined;
    }
    return `${this.sort.active},${this.sort.direction}`;
  }

}
